import { createReducer, on } from '@ngrx/store';
import * as EmployeeActions from './employee.actions';
import { Employee } from './employee.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface EmployeesState {
    employees: Employee[];
    employee: Employee | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialEmployeesState: EmployeesState = {
    employees: [],
    employee: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Employees Reducer
export const employeesReducer = createReducer(
    initialEmployeesState,

    // On Load Employees
    on(EmployeeActions.loadEmployees, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeActions.loadEmployeesSuccess, (state, { employees }) => ({
        ...state,
        isLoading: false,
        employees: employees,
    })),
    on(EmployeeActions.loadEmployeesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Employee
    on(EmployeeActions.loadEmployee, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeActions.loadEmployeeSuccess, (state, { employee }) => ({
        ...state,
        isLoading: false,
        employee: employee,
    })),
    on(EmployeeActions.loadEmployeeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(EmployeeActions.createEmployee, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeActions.createEmployeeSuccess, (state, { employee }) => ({
        ...state,
        isLoading: false,
        employees: [...state.employees, employee],
    })),
    on(EmployeeActions.createEmployeeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(EmployeeActions.updateEmployee, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeActions.updateEmployeeSuccess, (state, { employee }) => ({
        ...state,
        isLoading: false,
        employees: state.employees.map((_employee) =>
            _employee.id === employee.id ? employee : _employee
        ),
    })),
    on(EmployeeActions.updateEmployeeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(EmployeeActions.deleteEmployee, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeActions.deleteEmployeeSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        employees: state.employees.filter((employee) => employee.id !== id),
    })),
    on(EmployeeActions.deleteEmployeeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
